import { Global } from "./Global";
import Utils from "./Utils";
import Constant from "./Constant";
import NetworkLogic from "./NetworkLogic";
import UIManager from "./UIManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class WebViewManager extends cc.Component {
    @property(cc.Prefab)
    pfbConnectingLayer: cc.Node = null
    
    @property(cc.WebView)
    webView: cc.WebView = null

    @property(cc.Boolean)
    isFillNotch: boolean = true

    private _nodeConnectingBg: cc.Node = null
    private _isAgentRecharge: boolean = false;
    private _isIngame = false;

    onLoad () {
        this.webView.node.active = false
        cc.director.on(Global.UserEvent.OrientationChanged, this.onOrientationChanged, this)
        cc.director.on(Global.UserEvent.OpenMantain, this.openMaintain, this)
    }

    onDestroy () {
        cc.director.off(Global.UserEvent.OrientationChanged, this.onOrientationChanged, this)
    }

    openThirdGame (url) {
        this.openWebView(url)
        let scriptStr = "cc.find('Canvas').getComponent('WebViewManager').onBackHallFromGame();"
        this.createNativeButton(scriptStr);
        this.schedule(this._checkMaintain,15);
    }

    openMaintain(){
        if (this._isIngame){
            this.onBackHallFromGame()
            if (cc.sys.isBrowser) {
                let btn = document.getElementById('btn');
                btn && btn.remove();
            }
        }

    }

    _checkMaintain(time){
        cc.log("===time:",time);
        NetworkLogic.getTemplates([Constant.PackageFlag], function (data) {

        }.bind(this), function (response) {

        }.bind(this))

    }


    openAgentRecharge (url) {
        let that = this;
        this._isAgentRecharge = true
        this.openWebView(url)
        this.webView.setJavascriptInterfaceScheme("methods")
        this.webView.setOnJSCallback(function (target, url) {
            url = url.replace("methods://", "")
            let properties = url.split("&")
            let type = properties[0] ? properties[0].replace("type=", "") : ""

            if (type === "close") {
                this.closeWebView()
                this.webView.setJavascriptInterfaceScheme("")
                this.webView.setOnJSCallback(null)
            }else if (type === "saveimg") {
                let imgUrl = properties[1] ? properties[1].replace("url=", "") : ""
                if (imgUrl) {
                    // ios会少个冒号，原因未知
                    imgUrl = imgUrl.replace("http//", "http://")
                    imgUrl = imgUrl.replace("https//", "https://")
                    console.log("====进入 图片保存saveimg:");

                    Utils.saveUrlImageToAlbum(imgUrl, "web_save_image.png",function(success){
                        if (success){
                            console.log("====success:",success);
                            that.webView.evaluateJS(`window.alert("保存成功")`);
                        }else {
                            console.log("====error:",success);
                            this.webView.evaluateJS(`window.alert("保存失败")`);
                        }
                    }.bind(this))
                }
            }
        }.bind(this))
    }

    openOnlineKefu (url) {
        this.openWebView(url)
        let scriptStr = "cc.find('Canvas').getComponent('WebViewManager').onBackHall();"
        this.createNativeButton(scriptStr)
    }

    // 原生层返回按钮回调
    onBackHallFromGame () {
        this.closeWebView()
        cc.director.emit(Global.UserEvent.CloseThirdGame);
        this.unscheduleAllCallbacks()
    }

    onBackHall () {
        this.closeWebView()
    }

    onWebViewEvent (sender, event) {
        if (event === cc.WebView.EventType.LOADED) {
            cc.log("WebView Loaded!")
            if (this._nodeConnectingBg.active) {
                // 将webview拉回可视范围
                this.webView.node.y = 0
                this._nodeConnectingBg.active = false
                // 手动添加widget控件
                this.addWidgetComponent()
            }
        } else if (event === cc.WebView.EventType.LOADING) {
            cc.log("WebView Loading!")
        } else if (event === cc.WebView.EventType.ERROR) {
            cc.log("WebView Error!")
            // 银商页面如果加载失败则显示按钮
            if (this._isAgentRecharge) {
                let scriptStr = "cc.find('Canvas').getComponent('WebViewManager').onBackHall();"
                this.createNativeButton(scriptStr)
            }
        }
    }

    onOrientationChanged () {
        this.setWebViewWidgetSize()
    }
    
    private openWebView (url) {
        cc.log("webview网址：", url)
        Utils.hideGameNode()
        // 移到屏幕外
        this.webView.node.y = 1e5
        this.webView.url = url
        // active会立即触发webview事件。故写在设置url后面
        this.webView.node.active = true
        // 旋转会触发布局，即使wiget组建未激活（bug）。故先将其移除
        this.webView.getComponent(cc.Widget) && this.webView.node.removeComponent(cc.Widget)
        this._nodeConnectingBg = cc.instantiate(this.pfbConnectingLayer)
        this._nodeConnectingBg.parent = this.node

        this._isIngame = true;
    }

    private closeWebView () {
        Utils.showGameNode()
        this.isFillNotch = true
        this._nodeConnectingBg && this._nodeConnectingBg.destroy()
        this._nodeConnectingBg = null
        this._isAgentRecharge = false
        this.webView.node.active = false
        this.webView.url = ""
        Utils.setOrientation("H")
        this._isIngame = false;

    }

    private createNativeButton (scriptStr) {
        if (cc.sys.os === cc.sys.OS_IOS) {
            jsb.reflection.callStaticMethod("NativeUIManager", "createWebViewButton:scriptStr:", "btn.png", scriptStr);
        }else if (cc.sys.os === cc.sys.OS_ANDROID) {
            jsb.reflection.callStaticMethod("org/cocos2dx/javascript/NativeUIManager", "createWebViewButton", "(Ljava/lang/String;Ljava/lang/String;)V", "btn.png", scriptStr);
        }else if (cc.sys.isBrowser) {
            var bt =document.createElement("button");
            var gameDiv = document.getElementById("GameDiv");
            
            gameDiv.appendChild(bt); 
            bt.setAttribute('id','btn')

            let btn = document.getElementById('btn');
            btn.innerHTML = '返回大厅'; 
            btn.style.position =  'fixed';
            btn.style.top = '100px';
            btn.style.left = '100px';
            btn.addEventListener('click', function(){
                btn.remove()
                this.onBackHallFromGame()
            }.bind(this));
        }
    }

    private addWidgetComponent () {
        let wgt = this.webView.addComponent(cc.Widget)
        wgt.isAlignTop = true
        wgt.isAlignBottom = true
        wgt.isAlignLeft = true
        wgt.isAlignRight = true
        this.setWebViewWidgetSize()
    }

    private setWebViewWidgetSize () {
        let widget = this.webView.getComponent(cc.Widget)

        if (widget) {
            widget.top = 0
            widget.bottom = 0
            widget.left = 0
            widget.right = 0

            // 不能超过刘海区域
            if (!this.isFillNotch) {
                let size = cc.view.getFrameSize()
                
                // 利用宽高比判断刘海屏
                if (Math.max(size.width, size.height) / Math.min(size.width, size.height) > 2) {
                    if (size.width > size.height) {
                        widget.left = Constant.BangLength
                    }else {
                        widget.top = Constant.BangLength
                        widget.bottom = Constant.BangLength
                    }
                }
            }
        }
    }
}